import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { useNavigate } from 'react-router-dom';
import Notification from "../../Notification";


const AddFeature = () => {
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })

    const [featureTitle, setfeatureTitle] = useState('');
    const [serviceID, setServiceID] = useState('');
    const [serviceData, setServiceData] = useState([]);
    const [PackageID, setPackageID] = useState('');
    const [packageData, setPackageData] = useState([]);

    const addFeatureApi = () => {
        console.log(featureTitle, PackageID, serviceID);
        Axios
            .post("api/bussiness/services-package-feature", {
                feature_title: featureTitle,
                service_id: serviceID,
                package_id: PackageID,
            })
            .then((response) => {
                console.log(response);
                setfeatureTitle('');
                setNotify({
                    isOpen: true,
                    messsage: "Added Successfully",
                    type: 'success'
                })
            }).catch((error) => {
                // setNotify({
                //     isOpen: true,
                //     messsage: "already exits service",
                //     type: 'warning'
                // })
            });
    }

    const serviceApi = async (e) => {
        Axios
            .get(`/api/bussiness/get-plan-service-data`, {
            }).then((response) => {
                console.log(response);
                console.log(response.data.data.PlanServiceList[0])
                setServiceData(response.data.data.PlanServiceList[0]);
            }).catch(() => {
                console.log("Invalid Credentials");
            });
        console.log(serviceID);
    }
    const serviceList = serviceData.map((list) => {
        return (
            <option key={list.service_id} value={list.service_id}>{list.service_name}</option>
        )
    })

    const packageApi = async (e) => {
        Axios
            .get(`/api/bussiness/get-plan-package-data?service_id=${serviceID}`, {
            }).then((response) => {
                console.log(response);
                console.log(response.data.data.PlanServiceList[0])
                setPackageData(response.data.data.PlanServiceList[0]);
            }).catch(() => {
                console.log("Invalid Credentials");
            });
        console.log(PackageID);
    }
    const packageList = packageData.map((list) => {
        return (
            <option key={list.package_id} value={list.package_id}>{list.package_name}</option>
        )
    })

    return (
        <>
            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Add Feature</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="card-box" style={{ width: "50%", marginTop: "10px" }}>
                                <div className="form-group mb-3">
                                    <label htmlFor="service">Select Services</label>
                                    <select
                                        onChange={(e) => { setServiceID(e.target.value) }}
                                        id="service"
                                        type="text"
                                        className="form-control"
                                        onClick={serviceApi}
                                        style={{
                                            height: "50px", width: "100%"
                                        }}>
                                        <option>Select Services</option>
                                        {serviceList}
                                    </select>
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="package">Select Package</label>
                                    <select
                                        onChange={(e) => { setPackageID(e.target.value) }}
                                        id="package"
                                        type="text"
                                        className="form-control"
                                        onClick={packageApi}
                                        style={{
                                            height: "50px", width: "100%"
                                        }}>
                                        <option>Select Package</option>
                                        {packageList}
                                    </select>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="feature-name">Feature Name</label>
                                    <input
                                        onChange={(e) => setfeatureTitle(e.target.value)}
                                        id="feature-name"
                                        value={featureTitle}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Feature name"
                                    />

                                </div>

                                <button onClick={addFeatureApi} className="btn btn-gradient btn-block" type="submit"> Submit </button>
                                {
                                    notify.isOpen ?
                                        <Notification
                                            notify={notify}
                                            setNotify={setNotify} />
                                        : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddFeature;